import {ItemType} from '../types';
import {priority} from '@priority-software/priority-proto-api/lib';
import text from '../texts';
import {footerHeight, maxFreezeIndex, menuItemHeight} from '../consts';
import {PriorityIcon} from '@priority-software/priority-style-react';

export const getHideOption = (item, pack) => {
    const hiddenStatus = item.Hidden;
    const subMenuObj = [
        {
            title:
                hiddenStatus === priority.netitems.form.Hide.HiddenByPackage
                    ? text.show
                    : text.hide,
            action: MenuActions.HIDE,
            icon: null
        },
        {
            title: pack?.IsPackageVisible ? text.hidePackage : text.showPackage,
            action: MenuActions.HIDE_PACKAGE,
            icon: PriorityIcon.questionCircle
        }
    ];

    if (hiddenStatus === priority.netitems.form.Hide.HiddenByDesign) {
        return null;
    } else {
        return {
            title: !hiddenStatus ? text.hide : text.show,
            action: !pack ? MenuActions.HIDE : null,
            subMenu: pack ? subMenuObj : null
        };
    }
};

export enum MenuActions {
    RENAME = 1,
    FREEZE = 2,
    HIDE = 3,
    HIDE_PACKAGE = 4,
    SPACE = 5,
    MERGE = 6
}

export const getFieldMenuData = (
    item: ItemType,
    data: ItemType[] = null,
    isMandatory = false,
    pack = null
) => {
    let menuData = [];
    if (!item.Hidden) {
        if (item instanceof priority.netitems.form.TableViewColumnsDesign) {
            menuData = [{title: text.rename, action: MenuActions.RENAME}];
            if (!item.Cover && getVisibleIndex(data, item) <= maxFreezeIndex) {
                menuData.push({title: text.freezePane, action: MenuActions.FREEZE});
            }
        }
    }
    const hideOption = !isMandatory && getHideOption(item, pack);
    hideOption &&
        (menuData.length ? menuData.unshift(hideOption) : (menuData = hideOption.subMenu));
    return menuData;
};

const getVisibleIndex = (data: ItemType[], item: ItemType) => {
    const visibleItems: ItemType[] = data.filter(i => !i.Hidden);
    return visibleItems.indexOf(item);
};

export const isUpword = (ref, itemsCount) => {
    const node = ref.current;
    const triggerRect = node?.getBoundingClientRect();
    const expectedMenuHeight = itemsCount * menuItemHeight;
    if (triggerRect.top + expectedMenuHeight > window.innerHeight - footerHeight) {
        return true;
    }
    return false;
};
